// The "Better with Kent" playlist on Kent's YouTube channel. Episode watch
// links and embeds include this so viewers land in the full show playlist.
const betterWithKentPlaylistId = 'PLV5CVI1eNcJhP4nrJt85L7PxHjebFpDfY'

const externalLinks = {
	applePodcast:
		'https://podcasts.apple.com/us/podcast/chats-with-kent-c-dodds/id1475543959',
	pocketCasts: 'https://pca.st/12TG',
	spotify: 'https://open.spotify.com/show/7GkO2poedjbltWT5lduL5w',
	simpleCast: 'https://feeds.simplecast.com/X_wS_WYh',
	callKentApple:
		'https://podcasts.apple.com/us/podcast/call-kent-c-dodds/id1584425659',
	callKentPocketCasts: 'https://pca.st/rpottw98',
	callKentSpotify: 'https://open.spotify.com/show/6czfajqqSfPYD7bKZaFUNg',
	callKentRSS: 'https://feeds.transistor.fm/call-kent',
	betterWithKentYouTube:
		'https://www.youtube.com/@KentCDodds-vids?sub_confirmation=1',
	betterWithKentPlaylist: `https://www.youtube.com/playlist?list=${betterWithKentPlaylistId}`,
	betterWithKentApple:
		'https://podcasts.apple.com/us/podcast/better-with-kent/id1896798447',
	betterWithKentPocketCasts: 'https://pca.st/itunes/1896798447',
	betterWithKentSpotify: 'https://open.spotify.com/show/033lj6BDjJzIDM5k7iwNRU',
	betterWithKentRSS: 'https://feeds.transistor.fm/better-with-kent',
	discord: 'https://kcd.im/discord',
	translationContributions:
		'https://github.com/kentcdodds/kentcdodds.com/blob/main/CONTRIBUTING.md#translation-contributions',
	github: 'https://github.com/kentcdodds',
	githubRepo: 'https://github.com/kentcdodds/kentcdodds.com',
	youtube: 'https://youtube.com/c/KentCDodds-vids/videos',
	twitter: 'https://x.com/kentcdodds',
	x: 'https://x.com/kentcdodds',
	rss: 'https://kentcdodds.com/blog/rss.xml',
}

export { betterWithKentPlaylistId, externalLinks }
